import Repository from '../Repository';
import { useToast } from 'vue-toastification';
import { serialize } from 'object-to-formdata';
import _ from 'lodash';

const resource = '/auth';
const toast = useToast();

export default {
	signup(payload) {
		return Repository.post(`${resource}/signup`, payload);
	},
	login(payload) {
		return Repository.post(`${resource}/login`, payload);
	},
	loginOtp(payload) {
		return Repository.post(`${resource}/login/otp`, payload);
	},
	loginSocial(provider, data) {
		return Repository.post(`${resource}/login/social/${provider}`, data);
	},
	logout() {
		return Repository.get(`${resource}/logout`);
	},
	user() {
		return Repository.get(`${resource}/user`);
	},
	recoverSend(payload) {
		return Repository.post(`${resource}/recover/send`, payload).then((response) => {
			toast.success(`Código enviado.`);
			return response;
		});
	},
	recoverCheck(payload) {
		return Repository.post(`${resource}/recover/check`, payload).then((response) => {
			toast.success(`Usuario recuperado correctamente.`);
			return response;
		});
	},
	verifySend() {
		return Repository.post(`${resource}/verify/send`).then((response) => {
			toast.success(`Código enviado.`);
			return response;
		});
	},
	verifyCheck(payload) {
		return Repository.post(`${resource}/verify/check`, payload).then((response) => {
			toast.success(`Usuario verificado correctamente.`);
			return response;
		});
	},
	update(payload) {
		const formData = serialize(payload, { indices: true, nullsAsUndefineds: true });
		formData.append('_method', 'PUT');

		return Repository.post(`${resource}/user`, formData, { headers: { 'Content-Type': 'multipart/form-data' }}).then((response) => {
			toast.success(`Publicación actualizada correctamente.`);
			return response;
		});
	},
	preferences(payload) {
		return Repository.post(`${resource}/user/preferences`, _.set(payload, '_method', 'put')).then((response) => {
			toast.success(`Preferencias actualizadas correctamente.`);
			return response;
		});
	},
	password(payload) {
		return Repository.post(`${resource}/user/password`, _.set(payload, '_method', 'put')).then((response) => {
			toast.success(`Contraseña actualizada correctamente.`);
			return response;
		});
	},
	notificationTypes(payload) {
		return Repository.post(`${resource}/user/notificationTypes`, _.set(payload, '_method', 'put'));
	}
}